import { render, staticRenderFns } from "./PeriodsDetail.vue?vue&type=template&id=64d868e0&scoped=true&"
import script from "./PeriodsDetail.vue?vue&type=script&lang=js&"
export * from "./PeriodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsDetail.vue?vue&type=style&index=0&id=64d868e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d868e0",
  null
  
)

export default component.exports